<div [formGroup]="form">
  <div style="width: 400px">
    <div class="control required">
      <label>Beskrivelse</label>
      <input pInputText formControlName="beskrivelse" />
      @if (form.controls['beskrivelse'].errors &&
      form.controls['beskrivelse'].touched) {
        <p class="error">Feltet skal udfyldes</p>
      }
    </div>
    <div class="control">
      <label>Link</label>
      <input pInputText formControlName="jobLink" />
    </div>
    <div class="control">
      <label>Rækkefølge</label>
      <input pInputText formControlName="raekkeFoelge" />
    </div>

    <div class="flex gap-4">
      <p-button
        label="Gem ændringer"
        icon="pi pi-save"
        (click)="onClickSave()"
        [disabled]="!form.valid"
      />
      <p-button
        label="Slet jobopslag"
        icon="pi pi-trash"
        severity="danger"
        outlined
        (click)="onClickDelete($event)"
      />
    </div>
  </div>
</div>
<p-confirmDialog />
